<template>
    <div class="home-wrapper flex-height-max">
        <div v-if="user_email" class="home-wrapper-container">
            <div v-if="progress_bar_percentage > 0">
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="'width:'+progress_bar_percentage+'%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progress_bar_text}}</div>
                </div>
                <div style="text-align: left; font-size: 12px;">Setup progress</div>
            </div>
            <template>
                <div class="header-home">
                    Welcome! Let’s set up your protection!
                </div>
                <div class="flex-height-max flex-row">
                    <div class="content">
                        <div class="verify-title">🔔 Verify your email</div>
                        <div>Please enter the verification code that we sent to <span style="font-weight: 500">{{user_email}}</span></div>
                        <div v-if="flow === '1'">Should you have entered the wrong email during registration, do not panic and contact support using a chat window or by emailing support@ppcshield.io</span></div>
                        <custom-input
                            name="verify"
                            type="text"
                            label="Verification code"
                            classes="mt-2 mb-2"
                        ></custom-input>
                        <div>
                            If you don’t see it, please check your spam folder or <span class="resend_code" v-on:click="resendEmailVerificationCode">click here</span> to resend email.
                        </div>
                        <button class="btn btn-primary mt-2 w-100 p-2" v-on:click="verifyEmail">SUBMIT</button>
                    </div>
                    <div class="content-right-side">
                        <img class="right-img" src="/images/undraw_secure_login_pdn4.svg" alt="email verify">
                    </div>
                </div>
            </template>
        </div>

        <modal :height="'auto'" :width="widthForWaitModal" name="wait-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    If you didn't receive your reset email
                </div>

                <div class="body">
                    <div class="mb-3">Not sure where that email was sent? Here are some tips to help you find it.</div>
                    <div class="mb-3">1. We'll send the email from "PPC Shield", so you can quickly search for it. If it isn't in your inbox, check your folders. If a spam filter or email rule moved the email, it might be in the Spam, Junk, Trash, Deleted Items, or Archive folder.</div>
                    <div class="mb-3">2. Make sure you're checking the correct email inbox. The email address associated with your PPC Shield account is: {{user_email}}</div>
                    <div class="mb-3">3. After you have requested a verification code, you can request it again within 3 minutes.</div>
                    <div>4. If you're not getting any email, contact support using a chat window or by emailing support@ppcshield.io</div>
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('wait-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="widthForModal" name="email-send-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Email sent
                </div>

                <div class="body">
                    The new verification code has been successfully sent to {{user_email}}
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('email-send-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="widthForModal" name="error-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    {{dialogInfoTitle}}
                </div>

                <div class="body">
                    {{dialogInfoBody}}
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal('error-modal')">Close</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import VuePreloaders from 'vue-preloaders';
    import Infinite from '../shared/preloader.vue';
    Vue.use(VuePreloaders, {
        "component": Infinite,
        "overlayStyle": {
            "background": "rgba(0,0,0,.2)",
            "opacity": 1
        }
    });

    export default {
        props: ['user_email', 'progress_bar_percentage', 'progress_bar_text', 'flow'],
        data: function () {
            return {
                errors: {name: ''},
                dialogInfoTitle: '',
                dialogInfoBody: '',

                preloader: () => {},
            }
        },
        computed:{
            widthForModal(){
                return window.innerWidth > 400 ? '400px' : '300px';
            },
            widthForWaitModal(){
                return window.innerWidth > 600 ? '600px' : '300px';
            },
        },
        methods: {
            startPreloader() {
                this.preloader = this.$preloaders.open(/*{ options }*/);
            },
            stopPreloader() {
                this.preloader();
            },
            resendEmailVerificationCode(){
                axios.post('/setup/resendEmailVerificationCode')
                    .then(info => {
                        if(info.data.error){
                            this.showModal('wait-modal');
                        }
                        else{
                            this.showModal('email-send-modal');
                        }
                    })
                    .catch(info => {console.log('err')});
            },
            verifyEmail(){
                this.startPreloader();
                axios.post('/setup/verifyEmail', {verify: document.getElementById('verify').value})
                    .then(info => {
                        if(info.status === 200){
                            console.log(info.data);
                            window.location.href = info.data.route
                        }
                        else if(info.status === 201){
                            this.dialogInfoTitle = 'Error';
                            this.dialogInfoBody = info.data;
                            this.showModal('error-modal');
                        }
                        this.stopPreloader();
                    })
                    .catch(info => {this.stopPreloader(); console.log('err')});
            },
            showModal(modal_name) {
                this.$modal.show(modal_name);
            },
            hideModal(modal_name) {
                this.$modal.hide(modal_name);
            }
        },
        mounted() {

        }
    }
</script>
